import React, {FC} from "react";
import {
    useMediaQuery,
    useTheme,
} from "@mui/material";
import {GarageTableFiltersDesktop} from "./GarageTableFiltersDesktop";
import {GarageTableFiltersMobile} from "./GarageTableFiltersMobile";

interface Props {
    typeFilter: string | number | null;
    cityFilter: string | number | null;
    setTypeFilter: (val: string | number | null) => void;
    setCityFilter: (val: string | number | null) => void;
    onFilter: () => void;
    onReset: () => void;
    availableTypeOptions: {id: string; name: string}[];
    availableCityOptions: {id: string; name: string}[];
}

export const GarageTableFilters: FC<Props> = (props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return isMobile ? (
        <GarageTableFiltersMobile {...props} />
    ) : (
        <GarageTableFiltersDesktop {...props} />
    );
};
